import PropTypes from 'prop-types';

export const VALUE_TYPE_PERCENTAGE = 'percentage';
export const VALUE_TYPE_MONEY = 'money';
export const VALUE_TYPE_NUMBER = 'number';
export const VALUE_TYPE_TEXT = 'text';

const createField = (label, valueType, isEnabled = true) => ({
  label,
  valueType,
  isVisible: true,
  setting: {},
  value: 0,
  isEnabled,
});

const initCompanyFields = {
  assistenciaMedica: createField('Assitencia Médica', VALUE_TYPE_MONEY),
  odontologico: createField('Odontológico', VALUE_TYPE_MONEY),
  outrosCustos: createField('Outros Custos', VALUE_TYPE_MONEY),
  alimentacaoRefeicao: createField('Alimentação / Refeição', VALUE_TYPE_MONEY),
  percentualGps: createField('% GPS / INSS', VALUE_TYPE_PERCENTAGE),
};

const initFields = {
  remuneracaoBase: createField('Remuneração Base', VALUE_TYPE_MONEY),
  salario: createField('Salário', VALUE_TYPE_MONEY),
  transporte: createField('Transporte', VALUE_TYPE_MONEY),
  alimentacao: createField('Alimentação', VALUE_TYPE_MONEY),
  reembolso: createField('Reembolsos Diversos', VALUE_TYPE_MONEY),
  beneficios: createField('Cesta Benefícios', VALUE_TYPE_MONEY),
  valorAdicional: createField('Valor Adicional', VALUE_TYPE_MONEY),
  outrosDescontos: createField('Outros Descontos', VALUE_TYPE_MONEY),
  refeicao: createField('Refeição', VALUE_TYPE_MONEY),
  ajudaCusto: createField('Ajuda de Custo', VALUE_TYPE_MONEY),
  premio: createField('Prêmio', VALUE_TYPE_MONEY),
  pida: createField('PI/DA', VALUE_TYPE_MONEY, false),
  dependentes: createField('Dependentes', VALUE_TYPE_NUMBER),
};

const assignSettingsWithFields = (fields, settings) => {
  const entries = Object.entries(fields).map(([key, field]) => {
    const fieldVisibility = settings.fieldsVisibility[key];

    const { defaultValues, defaultCompanyValues } = settings;
    const setting = defaultValues[key] || defaultCompanyValues[key];
    return [
      key,
      {
        ...field,
        isVisible: (fieldVisibility && fieldVisibility.value) ?? true,
        setting,
      },
    ];
  });

  return Object.fromEntries(entries);
};

export const setupFields = (settings, fields) =>
  assignSettingsWithFields(fields || initFields, settings);
export const setupCompanyFields = (settings, fields) =>
  assignSettingsWithFields(fields || initCompanyFields, settings);

export const fieldShape = PropTypes.shape({
  id: PropTypes.string,
  value: PropTypes.number,
  isVisible: PropTypes.bool,
  isEnabled: PropTypes.bool,
  valueType: PropTypes.oneOf([
    VALUE_TYPE_PERCENTAGE,
    VALUE_TYPE_MONEY,
    VALUE_TYPE_NUMBER,
    VALUE_TYPE_TEXT,
  ]),
});

export const fieldsShape = PropTypes.objectOf(fieldShape);
